<template>
  <div class="controls">
    <b-button-group vertical size="sm">
      <b-button v-b-tooltip.hover.left="'Zoom In'" class="control" @click="$emit('zoom-in')">
        <font-awesome-icon icon="plus" />
      </b-button>

      <b-button
        v-b-tooltip.hover.left="'Zoom Out'"
        class="control minus"
        @click="$emit('zoom-out')"
      >
        <font-awesome-icon icon="minus" />
      </b-button>
    </b-button-group>

    <b-button
      v-b-tooltip.hover.left="'Recenter'"
      size="sm"
      class="control mt-1"
      @click="$emit('recenter')"
    >
      <font-awesome-icon :icon="['custom', 'recenter-visualisation']" />
    </b-button>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

@Component
export default class BubblesLegends extends Vue {}
</script>

<style scoped lang="scss">
.controls {
  position: absolute;
  bottom: 3rem;
  right: 0;
  display: flex;
  flex-direction: column;
  margin-right: 0.5rem;
}

.control {
  border: none;
  color: black;
  background-color: #eee;
  &:hover {
    background-color: #ccc;
  }
  &:focus,
  &:active,
  &:focus:active {
    box-shadow: none;
    outline: none;
  }
}

.minus {
  border-top-style: solid;
  border-top-width: 1px;
  border-top-color: white;
}
</style>
